"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const pulse_components_1 = require("@pcs/pulse-components");
const material_1 = require("@mui/material");
const utilities_1 = __importDefault(require("jsAssets/utilities"));
const useMutateJsonApi_1 = __importDefault(require("customHooks/useMutateJsonApi"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const helper_1 = require("../../helper");
const MoveReviewModalWrapper = ({ children, clientId, roundNumber = 1 }) => {
    const [reviewId, setReviewId] = react_1.default.useState(null);
    const [isOpen, setIsOpen] = react_1.default.useState(false);
    const [project, setProject] = react_1.default.useState();
    const [mutate, { loading, error }] = (0, useMutateJsonApi_1.default)(`${helper_1.URLS.app}api/reviews/${reviewId}/move`, pulse_components_1.METHODS.POST);
    const isDisablingConfirm = !project || loading;
    const handleOpen = (id) => {
        (0, react_1.startTransition)(() => {
            setReviewId(id);
        });
        setIsOpen(true);
    };
    const handleClose = () => {
        setIsOpen(false);
    };
    const onChange = (value) => {
        if (value.projectId) {
            setProject(value.projectId);
        }
    };
    const handleMoved = () => {
        window.location.href = `${helper_1.URLS.app}passport/${project === null || project === void 0 ? void 0 : project.value}/reviews#${reviewId}-${roundNumber}`;
    };
    const handleConfirmMove = () => {
        mutate({
            job_id: project === null || project === void 0 ? void 0 : project.value,
        }).then(() => {
            handleClose();
            handleMoved();
            utilities_1.default.notification.success('Review moved successfully.');
        });
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (!error)
            return;
        let failMessage = 'Failed to move the review. Please try again.';
        if (error === null || error === void 0 ? void 0 : error.data) {
            failMessage = (_a = error === null || error === void 0 ? void 0 : error.data.message) !== null && _a !== void 0 ? _a : failMessage;
        }
        utilities_1.default.notification.danger(failMessage);
    }, [error]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(pulse_components_1.PulseModalBase, { isV3: true, open: isOpen, onModalClose: handleClose, headerPrimaryText: 'Move Review to Another Project', classes: {
                root: [styles_modules_less_1.default['move-review-modal__body']],
                dialog: {
                    paper: styles_modules_less_1.default['move-review-modal__root'],
                },
                footer: {
                    confirm: ['confirm-move-btn'],
                },
            }, PulseModalHeaderProps: {
                isV3: true,
                classes: {
                    root: styles_modules_less_1.default['move-modal-header__root'],
                    titleContainer: styles_modules_less_1.default['move-modal-header__ctn'],
                    titlePrimary: styles_modules_less_1.default['move-modal-header__title'],
                    closeBtn: styles_modules_less_1.default['move-modal-header__closeBtn'],
                },
                headerIconClasses: (0, clsx_1.default)(styles_modules_less_1.default['move-modal-header__icon']),
            }, variant: "jqconfirm", onConfirmClick: handleConfirmMove, footerConfirmDisabled: isDisablingConfirm },
            react_1.default.createElement("div", { className: (0, clsx_1.default)(styles_modules_less_1.default['move-modal-content__root']), "data-testid": "move-review-modal" }, loading ? (react_1.default.createElement(material_1.CircularProgress, null)) : (react_1.default.createElement("div", { className: styles_modules_less_1.default['move-review-project-select'] },
                react_1.default.createElement(pulse_components_1.PulseProjectsSelect, { classes: {
                        root: styles_modules_less_1.default['review-select__root'],
                        label: styles_modules_less_1.default['review-select__label'],
                        select: styles_modules_less_1.default['review-select__menuCtn'],
                        placeholder: styles_modules_less_1.default['review-select__placeholder'],
                        selectContainer: styles_modules_less_1.default['review-select__selectContainer'],
                    }, extraParams: {
                        filter: {
                            jobstatus: 'active',
                            clientid: clientId,
                        },
                    }, isClearable: false, value: project, valueChangeHandler: onChange, labelName: "Select Project", placeholder: "Start typing to search for a project", insideModal: true, "data-testid": "project-select" }))))),
        children({
            handleOpenMoveReviewModal: handleOpen,
        })));
};
exports.default = MoveReviewModalWrapper;
